import { render, staticRenderFns } from "./LoadingApp.vue?vue&type=template&id=84c70e8e&scoped=true"
import script from "./LoadingApp.vue?vue&type=script&lang=ts"
export * from "./LoadingApp.vue?vue&type=script&lang=ts"
import style0 from "./LoadingApp.vue?vue&type=style&index=0&id=84c70e8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84c70e8e",
  null
  
)

export default component.exports